import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-use-before-define
MenuActions.Context = React.createContext();

function MenuActions({ children, ...rest }) {
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <MenuActions.Context.Provider value={{ ...rest }}>{children}</MenuActions.Context.Provider>
  );
}

MenuActions.propTypes = {
  children: PropTypes.node,
};

export default MenuActions;
